import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAppFeature } from '../models/feature';

export type featureType = 'strokeQueryType' | 'orderForm' | 'referralsTab';

@Injectable({
    providedIn: 'root'
})
export class FeaturesService {
    constructor(private readonly http: HttpClient) {}

    private _featureConfig: IAppFeature[];

    async load(): Promise<void> {
        const jsonFile = 'assets/config/features.json';
        try {
            const feature = (await this.http.get(jsonFile).toPromise()) as IAppFeature[];
            this.setFeature(feature);
        } catch (e) {
            throw Error(`Could not load file '${jsonFile}': ${JSON.stringify(e)}`);
        }
    }

    getFeature(): IAppFeature[] {
        return this._featureConfig;
    }

    setFeature(feature: IAppFeature[]): void {
        this._featureConfig = feature;
    }

    isFeatureEnabled(targetFeature: featureType, targetRegion: string): boolean {
        const featureArr = Array.from(this.getFeature() || []);
        if (!featureArr || !(featureArr instanceof Array)) {
            return false;
        }

        return featureArr.some(
            featureItem => featureItem.feature === targetFeature && (featureItem.countries || []).includes(targetRegion)
        );
    }
}
